import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationUserneedsData } from './Data';

export interface IntegrationUserneedsState extends BaseIntegrationState {
  endpoint?: string;
}

export class IntegrationUserneedsModel extends BaseIntegration<IntegrationUserneedsData, IntegrationUserneedsState> {
  parse(data: IntegrationUserneedsData) {
    super.parse(data);
    this.state.endpoint = data.settings?.endpoint;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/userneeds/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
